import { Pipe, PipeTransform } from '@angular/core';
import { InstallationWeightPluginService } from './weight.service';
@Pipe({
    name: 'weightunits',
    standalone: false
})
export class WeightUnitsPipe implements PipeTransform {
  public points: any[];
  constructor(private service: InstallationWeightPluginService) {
    this.points = this.service.getWeightUnits();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.points);
  }
}
